import React, { useCallback, useEffect } from 'react'
import { PrivateRoute, useSession } from '@emerald-works/react-auth'
import { UNAUTHORISED_ARK_GROUPS } from '../../util/userGroups'
import { useGroup } from '../../hooks'
import { routes } from '../../routes'
import { useArkMode } from '../../hooks/useArkMode'
import { useNavigate } from 'react-router'
import { useTenant } from '@emerald-works-nova/auth'
import { userHasAnyOfGroups } from '../../helpers/roles/user'
import { AllRolesStr } from '../../helpers/roles/department-data'
import { TOOLKIT_TYPE } from '../../util/constants'

export const ArkPrivateRoute = ({ allowedUserGroups, element }) => {
  const { session, isAuthenticated } = useSession()
  const tenant = useTenant()
  const { isInGroup } = useGroup()
  const { isAdminMode } = useArkMode()
  const navigate = useNavigate()
  const unauthorized = isAuthenticated && isInGroup(UNAUTHORISED_ARK_GROUPS)
  const navigateToRoute = useCallback((route) => {
    navigate(route)
  }, [navigate])

  useEffect(() => {
    if (!tenant || !session) return

    if (unauthorized) {
      navigateToRoute(routes.unauthorized.path)
    }

    if (isAdminMode) {
      if (isAuthenticated && session) {
        const onboarded = userHasAnyOfGroups(session, AllRolesStr)
        if (!onboarded) {
          navigateToRoute(routes.onboarding.path)
        }
      }
    } else {
      if (isAuthenticated) {
        const isSBT = tenant.toolkitType === TOOLKIT_TYPE.smallBusinessToolkit

        if (!isSBT) {
          navigateToRoute(routes.unauthorized.path)
        }
        navigateToRoute(`${process.env.PUBLIC_URL}/tenants/${tenant.pk}`)
      }
    }
  }, [unauthorized, navigateToRoute, session, isAuthenticated, isAdminMode, tenant])

  return (
    <PrivateRoute allowedUserGroups={allowedUserGroups} element={element} />
  )
}
